import "./HeroImgStyles.css";
import React from 'react'
import Red from '../assets/red2.png'
import {Link} from "react-router-dom";

const HeroImg = () => {
  return (
    <div className="hero">
      <div className="mask">
        <img src={Red} alt="My Pic" className="into-img" />
      </div>
      <div className="content" style={{zIndex:20}}>
        <h3>Hello, It's Me</h3>
        <h1>Harmanjot Kaur</h1>
        <h3>And I'm a <span>Devops Engineer Enthusiast</span></h3>
        <p>Committed and enthusiastic programmer with a keen interest in the dynamic and rapidly evolving realms of cloud computing and DevOps. My journey in technology is driven by a relentless pursuit of knowledge and a deep passion for innovation. Eager to contribute my technical skills and passion for cloud and DevOps in a collaborative environment, I am dedicated to delivering cutting-edge solutions. Despite being early in my career, my enthusiasm for coding and staying current with technological advancements make me a valuable asset for projects seeking fresh perspectives and innovative solutions.</p>
        <div className="buttons">
            <Link to="/project" className="btn">Projects</Link>
            <Link to="/contact" className="btn-light">Contact</Link>
        </div>
      </div>
    </div>
  )
}

export default HeroImg
